export default {
  init() {
    // JavaScript to be fired on the about us page

    $(".toggle-register").on("click", () => {
      $(".account-login--box").addClass("register");
    });

    $(".toggle-login").on("click", () => {
      $(".account-login--box").removeClass("register");
    });

    $(".account-section--menu--item").on("click", function () {
      let target = $(this).attr("data-target");
      let section = $(this).parent().parent().parent();
      section.find(".account-section--menu--item.active").removeClass("active");
      section.find(".account-section--view__item.active").removeClass("active");
      $(this).addClass("active");
      section.find(`.account-section--view__${target}`).addClass("active");
      history.pushState(target, target, `#account/${target}`);
    });

    // account saving
    $(".account_save").on("click", function () {
      let view = $(this).parent()[0];
      let inputs = view.querySelectorAll("input, select");
      let user_id = $(".account-area").attr("data-user");
      let formData = {};
      let btn = $(this);
      // console.log(inputs); // eslint-disable-line
      inputs.forEach((inp) => {
        if (inp.value && inp.value !== "password") {
          formData[inp.name] = inp.value;
          // formData[inp.name]["type"] = inp.type;
          // formData[inp.name]["value"] = inp.value;
        }
      });

      $(".account-area").addClass("loading");
      updateAccountMeta(user_id, formData, btn);
    });

    // rooming saving
    $(".rooming_save").on("click", function () {
      let view = $(this).parent()[0];
      let inputs = view.querySelectorAll("select");
      let btn = $(this);
      let order_id = btn.attr("data-order_id");
      let formData = {
        rooming: {},
      };
      inputs.forEach((inp) => {
        // if (inp.value && inp.value !== "password") {
        formData["rooming"][inp.name] = inp.value;
        // }
      });

      $(".account-area").addClass("loading");
      updateOrderMeta(order_id, formData, btn);
    });

    function updateOrderMeta(order_id, formData, btn) {
      completeWatch();
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "update_order_meta",
          form_data: formData,
          order_id: order_id,
        },
        success: function () {
          $(".account-area").removeClass("loading");
          btn.html("Updated!");

          setTimeout(() => {
            btn.html("Save Changes");
          }, 4000);
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
          btn.html("Error!");

          setTimeout(() => {
            btn.html("Save Changes");
          }, 4000);
        },
      });
    }

    // Rooming Watchers

    $(".trip-section--item-view--rooming").each(function () {
      let root = $(this);
      let selects = root.find("select");
      // let selected = $(this).attr("data-selected");
      selects.each(function () {
        $(this).on("change", function () {
          updateRoomingSelection(root);
        });
      });
      updateRoomingSelection(root);
    });

    function updateRoomingSelection(root) {
      let selects = root.find("select");
      let selected = new Array();
      selects.each(function () {
        if ($(this).val()) selected.push($(this).val());
      });
      root.attr("data-selected", selected.join(","));
      selects.each(function () {
        let options = $(this).find("option");
        options.each(function () {
          if (selected.includes($(this).val()) && !$(this).is(":selected")) {
            $(this).prop("disabled", "disabled");
          } else {
            $(this).prop("disabled", false);
          }
        });
      });
    }

    // // Add guest
    // $(".account_guest").on("click", function () {
    //   let view = $(this).parent()[0];
    //   let inputs = view.querySelectorAll("input, select");
    //   let user_id = $(".account-area").attr("data-user");
    //   let formData = {};
    //   let btn = $(this);
    //   let guests = $("body").find(".guests");
    //   let valid = true;

    //   inputs.forEach((inp) => {
    //     if (!inp.value) valid = false;
    //     if (inp.value && inp.value !== "password") {
    //       formData[inp.name] = inp.value;
    //     }
    //   });

    //   if (!valid) {
    //     alert("Missing Fields!");
    //     return;
    //   }

    //   console.log(formData); // eslint-disable-line
    //   $(".account-area").addClass("loading");
    //   updateAccountMeta(user_id, formData, btn, guests, inputs);
    // });

    function updateAccountMeta(user_id, formData, btn, guests, inputs) {
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "update_account_meta",
          form_data: {
            guest_obj: formData,
          },
          user_id: user_id,
        },
        success: function (response) {
          console.log(response); //eslint-disable-line
          $(".account-area").removeClass("loading");
          btn.html("Updated!");
          let guestData = JSON.parse(response);
          guests.html("");
          inputs.forEach((inp) => {
            inp.value = "";
          });
          Object.keys(guestData).forEach((key) => {
            let g = $("<div />", {
              class: "guest",
            }).attr("data-id", key);
            let label = $("<p />", {
              class: "text-large serif",
              text: `${guestData[key]["first_name"]} ${guestData[key]["last_name"]}`,
            });
            let del = $("<p />", {
              class: "del-guest text-x-small uppercase dark-grey bold",
              text: "x",
            }).attr("data-id", key);
            label.appendTo(g);
            del.appendTo(g);
            g.appendTo(guests);
          });

          setTimeout(() => {
            btn.html("Add");
          }, 4000);
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
          btn.html("Error!");

          setTimeout(() => {
            btn.html("Save Changes");
          }, 4000);
        },
      });
    }

    // Delete Guest
    $("body").on("click", ".del-guest", function () {
      let id = $(this).attr("data-id");
      let user_id = $(".account-area").attr("data-user");
      let name = $(this).parent().find(".guest-name").text();
      let guests = $("body").find(".guests");
      if (
        confirm(
          `Are you sure you wish to remove ${name} from your Friends & Family? This action is permanent and will remove them from any pending trips they may have been assigned to.`
        )
      ) {
        $.ajax({
          url: "/wp-admin/admin-ajax.php",
          type: "post",
          data: {
            action: "delete_guest",
            guest_id: id,
            user_id: user_id,
          },
          success: function (response) {
            $(".account-area").removeClass("loading");
            let guestData = JSON.parse(response);
            guests.html("");
            Object.keys(guestData).forEach((key) => {
              let g = $("<div />", {
                class: "guest",
              }).attr("data-id", key);
              let label = $("<p />", {
                class: "text-large serif",
                text: `${guestData[key]["first_name"]} ${guestData[key]["last_name"]}`,
              });
              let del = $("<p />", {
                class: "del-guest text-x-small uppercase dark-grey bold",
                text: "x",
              }).attr("data-id", key);
              label.appendTo(g);
              del.appendTo(g);
              g.appendTo(guests);
            });
          },
          error: function (err) {
            console.log(err); //eslint-disable-line
            $(".account-area").removeClass("loading");
            alert("Error deleting guest");
          },
        });
      }
    });

    // Trip Section view
    $(".trip-section--nav--item").on("click", function () {
      let view = $(this).attr("data-view");
      $(".trip-section--nav--item.active").removeClass("active");
      $(this).addClass("active");
      $(".trip-section--item-view.active").removeClass("active");
      $(`.trip-section--item-view--${view}`).addClass("active");
    });

    $(".trip-section--list-nav--item").on("click", function (e) {
      e.preventDefault();
      let view = $(this).attr("data-view");
      $(".trip-section--list-nav--item.active").removeClass("active");
      $(this).addClass("active");
      $(`.trip-section--list-nav--item[data-view="${view}"]`).addClass(
        "active"
      );
      $(".trip-section--item-view.active").removeClass("active");
      $(`.trip-section--item-view--${view}`).addClass("active");

      $([document.documentElement, document.body]).animate(
        {
          scrollTop:
            $(`.trip-section--item-view--${view}`).first().offset().top - 100,
        },
        1000
      );
      history.pushState(view, view, `?view=${view}`);
    });

    $(".trip-section--button").on("click", function (e) {
      e.preventDefault();
      let view = $(this).attr("data-view");
      $(".trip-section--list-nav--item.active").removeClass("active");
      $(this).addClass("active");
      $(`.trip-section--list-nav--item[data-view="${view}"]`).addClass(
        "active"
      );
      $(".trip-section--item-view.active").removeClass("active");
      $(`.trip-section--item-view--${view}`).addClass("active");

      $([document.documentElement, document.body]).animate(
        {
          scrollTop:
            $(`.trip-section--item-view--${view}`).first().offset().top - 100,
        },
        1000
      );
      history.pushState(view, view, `?view=${view}`);
    });




    $(".roadbook-section--list-nav--item").on("click", function () {
      let view = $(this).attr("data-view");
      $(".roadbook-section--list-nav--item.active").removeClass("active");
      $(".roadbook-section--view--content.active").removeClass("active");
      $(this).addClass("active");
      $(view).addClass("active");
      $([document.documentElement, document.body]).animate(
        {
          scrollTop:
            $(`.roadbook-section--item-view--${view}`).first().offset().top -
            100,
        },
        1000
      );
    });

    // bike pref
    $(".bike-pref--toggle").on("click", function () {
      $(this)
        .parent()
        .parent()
        .toggleClass("open")
        .find(".bike-pref--content")
        .toggleClass("active");
    });

    $(".bike-pref--item--title").on("click", function () {
      $(this)
        .parent()
        .toggleClass("open")
        .find(".bike-pref--content")
        .toggleClass("active");
    });

    $(".bikes_save").on("click", function () {
      $(".account-area").addClass("loading");
      let view = $(".bike-pref")[0];
      let inputs = view.querySelectorAll("input, textarea");
      let btn = $(this);
      let order_id = btn.attr("data-order_id");
      let formData = {
        bike_pref: {
          locked: true,
          mechanic_approved: false,
        },
      };

      inputs.forEach((inp) => {
        console.log(inp.name, inp.value); // eslint-disable-line
        formData["bike_pref"][inp.name] = inp.value;
      });

      btn.css("display", "none");

      updateOrderMeta(order_id, formData, btn);
    });

    // guests

    $(".edit-guest")
      .parent()
      .on("click", function () {
        $(this).toggleClass("open");
        $(this).parent().find(".trip-guest--item--edit").toggleClass("active");
      });

    $(".trip_account_guest").on("click", function () {
      completeWatch();
      let view = $(this).parent()[0];
      let editForm = $(this).parent();
      let inputs = view.querySelectorAll("input, select");
      let user_id = $(this).attr("data-id");
      let formData = {};
      let btn = $(this);
      let guest_id = $(this).attr("data-guest_id");

      inputs.forEach((inp) => {
        formData[inp.name] = inp.value;
      });

      $(".account-area").addClass("loading");
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "update_account_meta",
          form_data: {
            guest_obj: formData,
          },
          user_id: user_id,
          guest_id: guest_id,
        },
        success: function () {
          $(".account-area").removeClass("loading");
          btn.html("Updated!");

          setTimeout(() => {
            btn.html("Save Changes");
            // view.classList.remove("active");
            editForm
              .parent()
              .find(".p-user-name")
              .text(`${formData["first_name"]} ${formData["last_name"]}`);
          }, 500);
        },
        error: function () {
          $(".account-area").removeClass("loading");
          btn.html("Error!");

          setTimeout(() => {
            btn.html("Save Changes");
          }, 4000);
        },
      });
    });

    // clothing

    $(".edit-guest-clothing")
      .parent()
      .on("click", function () {
        $(this).toggleClass("open");
        $(this)
          .parent()
          .find(".clothing-pref--item--edit")
          .toggleClass("active");
      });

    $(".clothing_save").on("click", function () {
      $(".account-area").addClass("loading");
      let btn = $(this);
      let order_id = btn.attr("data-order_id");
      let view = $(this).parent()[0];
      let inputs = view.querySelectorAll("input, select");
      let formData = {
        clothing_pref: {},
      };

      inputs.forEach((inp) => {
        if (inp.type === "radio") {
          if (inp.checked) {
            formData["clothing_pref"][inp.name] = inp.value;
          }
        } else {
          formData["clothing_pref"][inp.name] = inp.value;
        }
      });

      updateOrderMeta(order_id, formData, btn);
    });

    $(".diet_save").on("click", function () {
      $(".account-area").addClass("loading");
      let btn = $(this);
      let order_id = btn.attr("data-order_id");
      let view = $(this).parent()[0];
      let inputs = view.querySelectorAll("textarea, input");
      let formData = {};

      inputs.forEach((inp) => {
        let val = inp.value;
        if (inp.type === "checkbox") {
          val = inp.checked ? "true" : "false";
        }
        formData[inp.name] = val;
      });

      updateOrderMeta(order_id, formData, btn);
    });

    // Medical Conditions

    $(".edit-guest-mc")
      .parent()
      .on("click", function () {
        $(this).toggleClass("open");
        $(this)
          .parent()
          .find(".medical-condition--item--edit")
          .toggleClass("active");
      });

    $(".m-insurance_save").on("click", function () {
      $(".account-area").addClass("loading");
      let btn = $(this);
      let order_id = btn.attr("data-order_id");
      let view = $(this).parent()[0];
      let inputs = view.querySelectorAll("input");
      let formData = {};

      inputs.forEach((inp) => {
        formData[inp.name] = inp.value;
      });

      updateOrderMeta(order_id, formData, btn);
    });

    // Medical Insurance

    $(".edit-guest-mi")
      .parent()
      .on("click", function () {
        $(this).toggleClass("open");
        $(this)
          .parent()
          .find(".medical-insurance--item--edit")
          .toggleClass("active");
      });

    $(".m-conditions_save").on("click", function () {
      $(".account-area").addClass("loading");
      let btn = $(this);
      let order_id = btn.attr("data-order_id");
      let view = $(this).parent()[0];
      let inputs = view.querySelectorAll("textarea, input");
      let formData = {};

      inputs.forEach((inp) => {
        if (inp.type === "checkbox") {
          formData[inp.name] = inp.checked;
        } else {
          formData[inp.name] = inp.value;
        }
      });

      updateOrderMeta(order_id, formData, btn);
    });

    // Emergency Contact

    $(".edit-guest-em")
      .parent()
      .on("click", function () {
        $(this).toggleClass("open");
        $(this).parent().find(".emergency--item--edit").toggleClass("active");
      });

    $(".emergency_save").on("click", function () {
      $(".account-area").addClass("loading");
      let btn = $(this);
      let order_id = btn.attr("data-order_id");
      let view = $(this).parent()[0];
      let inputs = view.querySelectorAll("input");
      let formData = {};

      inputs.forEach((inp) => {
        formData[inp.name] = inp.value;
      });

      updateOrderMeta(order_id, formData, btn);
    });

    // Travel Details
    $(".travel_save").on("click", function () {
      $(".account-area").addClass("loading");
      let btn = $(this);
      let order_id = btn.attr("data-order_id");
      let view = $(this).parent()[0];
      let inputs = view.querySelectorAll("select, textarea");
      let formData = {
        travel_pref: {},
      };

      inputs.forEach((inp) => {
        if (inp.type === "radio") {
          if (inp.checked) {
            formData["travel_pref"][inp.name] = inp.value;
          }
        } else {
          formData["travel_pref"][inp.name] = inp.value;
        }
      });

      updateOrderMeta(order_id, formData, btn);
    });

    // Complete watch
    function completeWatch() {
      $(".trip-section--list-nav").each(function () {
        let trip = $(this).attr("data-id");
        $(this)
          .find(".trip-section--list-nav--item")
          .each(function () {
            let navItem = $(this);
            let type = $(this).attr("data-view");
            let view = $(`.trip-section--view__${trip}`).find(
              `.trip-section--item-view--${type}`
            );
            let complete = true;

            let tripMeta = {};
            tripMeta.order_id = trip;
            tripMeta.type = type;
            const formObjGuests = $(this).serializeObject();
            tripMeta.guests = formObjGuests.guests;

            if (complete && type !== "ride-info") {
              view.find("input, select, textarea").each(function () {
                $(this).css("outline", "none");
                let defaultToggle = $(this)
                  .parent()
                  .parent()
                  .find(`input[type="checkbox"]`);
                if (defaultToggle.length > 0) {
                  if (
                    !$(this).val() &&
                    !$(this).hasClass("optional") &&
                    defaultToggle.is(":checked") !== true
                  ) {
                    complete = false;
                    $(this).css("outline", "solid 1px red");
                  }
                } else if (!$(this).val() && $(this).attr("type") !== "hidden") {
                  if (!$(this).hasClass("optional")) {
                    complete = false;
                    $(this).css("outline", "solid 1px red");
                  }
                }
              });
              if ( complete )
              {
                if ( type == "dietary" || type == "medical" || type == "insurance" || type == "emergency" || type == 'bike-fit' )
                {
                   $.ajax({
                    url: "/wp-admin/admin-ajax.php",
                    type: "post",
                    dataType: "json",
                    data: {
                      action: "check_trip_meta_values",
                      form_data: tripMeta,
                    },
                    success: function (response) {
                      if (response.complete)
                      {
                        navItem.addClass("complete");
                      }
                    },
                  });
                }
                else
                {
                  navItem.addClass("complete");
                }
              }
              else
              {
                navItem.removeClass("complete");
              }
            }
          });
      });
    }

    completeWatch();

    // Amend Trip

    $("body").on("click", ".edit-bike", function () {
      let name = $(this).parent().attr("data-name");
      let modal = $(this).attr("data-micromodal-trigger");
      let guestId = $(this).parent().attr("data-guest-id");
      let modalel = $(`#${modal}`);
      modalel.find(".edit-bike--guest-name").text(name);
      modalel.find(".amend-trip--submit").attr("data-guest-id", guestId);
    });

    $(".amend-trip--submit").on("click", function () {
      let tripId = $(this).attr("data-order-id");
      let guestId = $(this).attr("data-guest-id");
      let data = {
        action: "amend_trip_request",
        trip_id: tripId,
        guest_id: guestId,
      };
      let inp = $(this).parent().find("input, select");
      for (let i = 0; i < inp.length; i++) {
        let name = inp[i].getAttribute("name");
        let value = inp[i].value;
        console.log(name, value); // eslint-disable-line
        data[name] = value;
      }
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        dataType: "json",
        data: data,
        success: function () {
          location.reload();
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          alert("Sorry your request failed, please try again later.");
        },
      });
    });

    function checkForLocked() {
      $(".trip-section--view__item").each(function () {
        let locked = $(this).hasClass("locked");
        // locked = true; // this for debug testing
        if (locked) {
          $(this).find("input, select, textarea").prop("readonly", true);
          $(this)
            .find(".trip-section--item-view")
            .each(function () {
              console.log($(this)); //eslint-disable-line
              if (!$(this).hasClass("trip-section--item-view--overview")) {
                $(this).find(".btn").remove();
              }
              $(this).prepend(
                $("<div />", {
                  class: "trip-section--item-view--notification",
                  text: "This trip is now too close to departure to edit, for any amends please use the amend trip button on the trip overview page",
                })
              );
            });
        }
      });
    }

    checkForLocked();

    $(".form-order-guests").on("submit", function (e) {
      e.preventDefault();
      $(".account-area").addClass("loading");
      let tripMeta = {};
      tripMeta.order_id = $(this).data("order_id");
      const formObjGuests = $(this).serializeObject();
      tripMeta.guests = formObjGuests.guests;
      tripMeta.bikes = formObjGuests.bikes;
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        dataType: "json",
        data: {
          action: "update_order_trip_meta_guests",
          form_data: tripMeta,
        },
        success: function (guests) {
          $(".account-area").removeClass("loading");
          location.reload();
          completeWatch();
          for (var j = 0; j < guests.length; j++) {
            $(
              ".trip-section--view__" + tripMeta.order_id + " .guest-name-" + j
            ).text(guests[j].first_name + " " + guests[j].last_name);
          }
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
        },
      });
    }); 

    $(".form-order-rooming").on("submit", function (e) {
      e.preventDefault();
      $(".account-area").addClass("loading");
      let tripMeta = {};
      tripMeta.order_id = $(this).data("order_id");
      const formObjRooming = $(this).serializeObject();
      tripMeta.rooming = formObjRooming.rooming;
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        dataType: "json",
        data: {
          action: "update_order_trip_meta_rooming",
          form_data: tripMeta,
        },
        success: function () {
          $(".account-area").removeClass("loading");
          location.reload();
          completeWatch();
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
        },
      });
    });

    $(".form-order-bikes").on("submit", function (e) {
      e.preventDefault();
      $(".account-area").addClass("loading");
      let tripMeta = {};
      tripMeta.order_id = $(this).data("order_id");
      const formObj = $(this).serializeObject();
      tripMeta.bikes = formObj.bikes;
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        dataType: "json",
        data: {
          action: "update_order_trip_meta_bikes",
          form_data: tripMeta,
        },
        success: function () {
          $(".account-area").removeClass("loading");
          location.reload();
          completeWatch();
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
        },
      });
    });

    $(".form-order-dietary").on("submit", function (e) {
      e.preventDefault();
      $(".account-area").addClass("loading");
      let tripMeta = {};
      tripMeta.order_id = $(this).data("order_id");
      const formObj = $(this).serializeObject();
      tripMeta.guests = formObj.guests;
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        dataType: "json",
        data: {
          action: "update_order_trip_meta_dietary",
          form_data: tripMeta,
        },
        success: function () {
          $(".account-area").removeClass("loading");
          location.reload();
          completeWatch();
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
        },
      });
    });

    $(".form-order-medical-conditions").on("submit", function (e) {
      e.preventDefault();
      $(".account-area").addClass("loading");
      let tripMeta = {};
      tripMeta.order_id = $(this).data("order_id");
      const formObj = $(this).serializeObject();
      tripMeta.guests = formObj.guests;
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        dataType: "json",
        data: {
          action: "update_order_trip_meta_medical",
          form_data: tripMeta,
        },
        success: function () {
          $(".account-area").removeClass("loading");
          location.reload();
          completeWatch();
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
        },
      });
    });

    $(".form-order-insurance").on("submit", function (e) {
      e.preventDefault();
      $(".account-area").addClass("loading");
      let tripMeta = {};
      tripMeta.order_id = $(this).data("order_id");
      const formObj = $(this).serializeObject();
      tripMeta.guests = formObj.guests;
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        dataType: "json",
        data: {
          action: "update_order_trip_meta_insurance",
          form_data: tripMeta,
        },
        success: function () {
          $(".account-area").removeClass("loading");
          location.reload();
          completeWatch();
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
        },
      });
    });

    $(".form-order-emergency").on("submit", function (e) {
      e.preventDefault();
      $(".account-area").addClass("loading");
      let tripMeta = {};
      tripMeta.order_id = $(this).data("order_id");
      const formObj = $(this).serializeObject();
      tripMeta.guests = formObj.guests;
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        dataType: "json",
        data: {
          action: "update_order_trip_meta_emergency",
          form_data: tripMeta,
        },
        success: function () {
          $(".account-area").removeClass("loading");
          location.reload();
          completeWatch();
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
        },
      });
    });

    $(".form-order-travel").on("submit", function (e) {
      e.preventDefault();
      $(".account-area").addClass("loading");
      let tripMeta = {};
      tripMeta.order_id = $(this).data("order_id");
      const formObj = $(this).serializeObject();
      tripMeta.travel = formObj.travel;
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        dataType: "json",
        data: {
          action: "update_order_trip_meta_travel",
          form_data: tripMeta,
        },
        success: function () {
          $(".account-area").removeClass("loading");
          location.reload();
          completeWatch();
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
        },
      });
    });

    $(".form-order-bike-fit").on("submit", function (e) {
      e.preventDefault();
      $(".account-area").addClass("loading");
      let tripMeta = {};
      tripMeta.order_id = $(this).data("order_id");
      const formObj = $(this).serializeObject();
      tripMeta.guests = formObj.guests;
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        dataType: "json",
        data: {
          action: "update_order_trip_meta_bike_fit",
          form_data: tripMeta,
        },
        success: function () {
          $(".account-area").removeClass("loading");
          location.reload();
          completeWatch();
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
          $(".account-area").removeClass("loading");
        },
      });
    });

    setTimeout(() => {
      hashRouter();
    }, 200);

    function hashRouter() {
      let hash = window.location.hash.replace("#", "");

      if (hash) {
        let hashObj = hash.split("/");
        let root = hashObj[0];
        let sub = false;
        if (hashObj.length > 1) {
          sub = hashObj[1];
        }
        $(`.account-area--sidebar--item[data-target="${root}"]`).click();
        if (sub) {
          setTimeout(() => {
            $(`.account-area--content__${root}`)
              .find(`div[data-target="${sub}"]`)
              .click();
          }, 100);
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/myAccount.js